export const getSize = (x, fullSize) => `${Math.min(x / fullSize, 1) * 100}%`;
